import { Component, Input, input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContentService } from '../../services/content.service';

@Component({
  selector: 'app-upload-document-modal',
  templateUrl: './upload-document-modal.component.html',
  styleUrl: './upload-document-modal.component.scss'
})
export class UploadDocumentModalComponent {

  isUploading = false;
  selectedFile: File | null = null;
  sanitizedFileName = "";
  uploadProgress = 0;
  savingMetadata = false;
  uploadSuccessful = false;

  @Input() userId!: string;
  @Input() journeySectionId!: string;
  @Input() sectionId!: string;
  @Input() s3BucketName!: string;

  constructor(public activeModal: NgbActiveModal, private contentService: ContentService){

  }

  sanitizeFileName(fileName: string): string {
    return fileName.replace(/\s+/g, "_") // Replace spaces with underscores
                   .replace(/[^a-zA-Z0-9._-]/g, ""); // Remove special characters except dots, underscores, and hyphens
  }

  close(){
    this.activeModal.close("Dismissed by user");
  }

  onFileSelected(event: any){
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.uploadProgress = 0;
      this.uploadSuccessful = false;
      this.savingMetadata = false;
    }
  }

  uploadDocument(){
    if (!this.selectedFile) {
      return;
    }

    const MAX_FILE_SIZE = 5 * 1024 * 1024;

    if (this.selectedFile.size > MAX_FILE_SIZE) {
      console.error("File size exceeds 5MB limit.");
      alert("File size must be 5MB or smaller."); // Show an error message to user
      return;
    }

    this.isUploading = true;
    this.uploadProgress = 0;

    this.sanitizedFileName = this.sanitizeFileName(this.selectedFile.name);
    const contentType = this.selectedFile.type;

    this.contentService.generateUploadUrl(this.sanitizedFileName, contentType).subscribe({
      next: (response) => {
        console.log("Pre-signed URL received:", response.uploadUrl);
        this.uploadToS3(response.uploadUrl, this.selectedFile!);
      },
      error: (error) => {
        console.error("Error getting upload URL:", error);
        this.isUploading = false;
      }
    });

  }

  uploadToS3(uploadUrl: string, file: File) {
    const renamedFile = new File([file], this.sanitizedFileName, { type: file.type });

    this.contentService.uploadFileToS3(uploadUrl, renamedFile).subscribe({
      next: (event) => {
        if(event.total){
          this.uploadProgress = Math.round((event.loaded / event.total) * 100);
        }
        

        if (event.type === 4) { // HTTP response received
          this.isUploading = false;
          // Step 3: Save file metadata in the backend
          this.saveFileMetadata(file);
        }
      },
      error: (error) => {
        console.error("Error uploading file to S3:", error);
        this.isUploading = false;
      }
    });
  }

  // TODO: add dynamic params!!!!!
  saveFileMetadata(file: File) {

    this.savingMetadata = true;
    this.contentService.saveMetaData({
      sectionId: this.sectionId,
      userJourneyStatusId: this.journeySectionId, // Replace with actual ID
      uploadUserId: this.userId, // Replace with logged-in user ID
      s3Url: `https://${this.s3BucketName}.s3.amazonaws.com/uploads/${this.sanitizedFileName}`,
      fileName: this.sanitizedFileName,
      fileType: file.type,
      fileSize: file.size
    }).subscribe({
      next: (response) => {
        this.isUploading = false;
        this.savingMetadata = false
        this.uploadSuccessful = true;
        setTimeout(() => {
          this.activeModal.close("file uploaded successfully");
        }, 5000);

      },
      error: (error) => {
        console.error("Error saving file metadata:", error)
      this.isUploading = false;
      }
    });
  }
}
